<ng-container [formGroup]="GenForm">

<div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">		

    <!-- cell : Anamnesis -->

    <div class="w50 summary-anamnesis" style="height: 50%;">

        <section class="m-box">

            <h2>
                Medical History
            </h2>

            <button class="t-btn-smart" *ngIf="!es.isClosed && ls.premissions && ls.premissions.Questionnaires"
                [disabled]="aiSummaryLoading" style="margin-bottom: 0.5em" (click)="getAiSummary()">{{ 'GUI.General.Buttons.Populate Smart History' | translate }}
                <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
            </button>
            <textarea class="scroller" formControlName="MedicalHistory">

            </textarea><!-- /scroller -->
            <h4 style="margin: 0;">Obsetrical Formula</h4>
            <div style="display: flex;padding: 1em 0;justify-content: space-between;">
                <div style="width: 100%;display: flex">
                    <section style="margin-inline-end: 1em;">
                        Gravida
                        <select class="t-select t-field" formControlName="Gravida">
                            <ng-container *ngFor="let _ of [].constructor(25), let i = index">
                                <option value="{{i}}">{{i}}</option>
                            </ng-container>
                        </select>
                    </section>
                    <section style="margin-inline-end: 1em;">
                        Para
                        <select class="t-select t-field" formControlName="Para">
                            <ng-container *ngFor="let _ of [].constructor(25), let i = index">
                                <option value="{{i}}">{{i}}</option>
                            </ng-container>
                        </select>
                    </section>
                    <section style="margin-inline-end: 1em;">
                        Abortion
                        <select class="t-select t-field" formControlName="Abortion">
                            <ng-container *ngFor="let _ of [].constructor(25), let i = index">
                                <option value="{{i}}">{{i}}</option>
                            </ng-container>
                        </select>
                    </section>
                </div>
            </div>
            <button class="t-btn-edit" *ngIf="! es.isClosed && lastMed" (click)="addLastMed()" style="margin-right: 6em" >Previous Medical History</button>
            <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(GenForm.get('MedicalHistory'),'Medical History',1)">Auto Text</button>

        </section>
    
    </div>
    <!-- endcell : Anamnesis -->

    <!-- cell : Reason for Examinanion -->
    
    <div class="w50 summary-recommendations" style="height: auto;">

        <section class="m-box">

            <h2>
                Reason for Examination
            </h2>

            <textarea class="scroller" formControlName="Purpose">
                
            </textarea><!-- /scroller -->
            
            <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(GenForm.get('Purpose'),'Reason for Examinanion',92)">Auto Text</button>
            
        </section>

    </div>

    <!-- endcell : Reason for Examinanion -->

</div>

<!-- box (start) -->
<section class="m-box" style="margin-top: 1em;">

    <h2>
        Last Menstrual
    </h2>
    
    <div class="pregnancy-menstrual">
        
        <!-- row (start) -->
        <div class="l-flex-c menstrual-row menstrual-row--LMP">

            <label class="l-fg1 menstural-label" id="menstural_LMP">
                L.M.P.
            </label>
            
            <span class="l-flex t-boxMargin menstural-fields-set">
                    
                <input [matDatepicker]="LMPDatepicker" (focus)="LMPDatepicker.open()" (click)="LMPDatepicker.open()" formControlName="LMP" readonly  class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP">
                <mat-datepicker #LMPDatepicker></mat-datepicker>
                <span class="t-field menstural-field menstural-info">{{days()}} <ng-container *ngIf="days()">Days</ng-container></span>

            </span>

        </div>
        <!-- row (end) -->


    </div>

</section>
<!-- box (end) -->

</ng-container>